// extracted by mini-css-extract-plugin
export default {"overlay":"copyableOverlayTrigger_overlay__GjEy9"};